<template>
    <div class="container">
        <!-- 轮播图 -->
        <van-swipe :height="120" class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(image, index) in images" :key="index">
                <img v-lazy="image" />
            </van-swipe-item>
        </van-swipe>

        <van-notice-bar left-icon="volume-o" :scrollable="false">
            <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
                <van-swipe-item v-for="item in notices" @click="noticeDetail(item)">{{ item.noticeTitle
                    }}</van-swipe-item>
            </van-swipe>
        </van-notice-bar>

        <!-- 快捷菜单 两端对齐 -->
        <van-row class="mine-col" type="flex" justify="space-between">
            <van-col span="4" @click="toCharts">
                <div class="menu-icon-bg bg-color1">
                    <van-icon name="medal" size="23" color="#fff" />
                </div>
                <span>排行榜</span>
            </van-col>
            <van-col span="4" @click="apply">
                <div class="menu-icon-bg bg-color2">
                    <van-icon name="edit" size="22" color="#fff" />
                </div>
                <span>申请专家</span>
            </van-col>
            <van-col span="4" @click="toRecommend">
                <div class="menu-icon-bg bg-color3">
                    <van-icon name="fire" size="22" color="#fff" />
                </div>
                <span>热门优选</span>
            </van-col>
            <van-col span="4" @click="toCustom">
                <div class="menu-icon-bg bg-color4">
                    <van-icon name="audio" size="22" color="#fff" />
                </div>
                <span>客服</span>
            </van-col>
            <van-col span="4" @click="toRecommendForFree">
                <div class="menu-icon-bg bg-color5">
                    <van-icon name="chart-trending-o" size="22" color="#fff" />
                </div>
                <span>免费分析</span>
            </van-col>
        </van-row>

        <van-divider
            :style="{ color: '#1989fa', borderColor: '#F1F1F1', backgroundColor: '#F1F1F1', height: '5px', margin: '20px 0' }">
        </van-divider>

        <MavinListTop :mavinTopList="dantiaoMavins" :mavinTopList2="dantiaoMavins2" :areaId="1" :LotId="1">
        </MavinListTop>

        <van-divider
            :style="{ color: '#1989fa', borderColor: '#F1F1F1', backgroundColor: '#F1F1F1', height: '5px', margin: '20px 0' }">
        </van-divider>

        <MavinListTopForCondition :mavinList="conditionMavins" :mavinList2="conditionMavins2" :areaId="4" :days="days">
        </MavinListTopForCondition>

        <van-divider
            :style="{ color: '#1989fa', borderColor: '#F1F1F1', backgroundColor: '#F1F1F1', height: '5px', margin: '20px 0' }">
        </van-divider>

        <!-- 大底推荐 -->
        <CaseList :postList="hotPostList"></CaseList>

        <van-divider style="margin-top: 30px;">再无更多</van-divider>

    </div>
</template>

<script>
import { home } from '@/api'
import MavinListTop from '@/components/MavinListTop'
import MavinListTopForCondition from '@/components/MavinListTopForCondition'
import CaseList from '@/components/CaseList'

export default {
    name: 'HomeContent',
    components: { MavinListTop, MavinListTopForCondition, CaseList },
    data() {
        return {
            // 公告
            notices: [],
            // 轮播图
            images: [
                require('@/assets/img/swipe/lunbo1.jpg'),
                require('@/assets/img/swipe/lunbo2.jpg'),
                require('@/assets/img/swipe/lunbo3.jpg'),
            ],
            // 单挑专家
            dantiaoMavins: [],
            dantiaoMavins2: [],
            // 条件专家
            conditionMavins: [],
            conditionMavins2: [],
            // 排行统计的天数
            days: 100,
            // 热帖列表
            hotPostList: [],
        }
    },
    created() {
        this.getNotice()
        this.getDantiaoMavinTop(1, 9)
        this.getConditionMavinTop(4, this.days)
        this.getDaDiPostTop()
        // // 注册通过切换玩法属性来查询专家排行榜的事件到全局消息总线
        // this.$bus.$on('change-playtype-attribute', this.getConditionMavinTop)
    },
    beforeDestroy() {
        // this.$bus.$off('change-playtype-attribute')
    },
    methods: {
        // 免费方案
        toRecommendForFree(){
            this.$router.push({
                path: '/recommend',
                query: {
                    areaId: 5
                }
            })
        },
        // 申请排行榜
        apply(){
            this.$notify({
                type: 'success',
                message: '暂停开放申请，开放时间另行公开，请持续关注'
            })
        },

        // 去排行榜
        toCharts(){
            this.$router.push('/charts')
        },
        
        // 去推荐页
        toRecommend(){
            this.$router.push('/recommend')
        },
        
        // 去客服页
        toCustom(){
            this.$router.push('/custom')
        },

        // 帖子TOP排行查询
        async getDaDiPostTop(){
            const list = await home.getPostTop(2)
            this.hotPostList = list || []
        },
        // 条件专家TOP
        async getConditionMavinTop(areaId, days) {
            // 选号推荐
            this.conditionMavins = []
            const list = await home.getMavinTopByAttribute(areaId, days, 1)
            this.conditionMavins = list || []
            // 选号推荐
            this.conditionMavins2 = []
            const list2 = await home.getMavinTopByAttribute(areaId, days, 2)
            this.conditionMavins2 = list2 || []
        },

        // 单挑专家TOP
        async getDantiaoMavinTop(areaId, limit = 9) {
            // 加载3D
            this.dantiaoMavins = []
            const list = await home.getMavinTop(1, areaId, limit)
            this.dantiaoMavins = list || []
            // 加载P3
            this.dantiaoMavins2 = []
            const list2 = await home.getMavinTop(2, areaId, limit)
            this.dantiaoMavins2 = list2 || []
        },

        // 查看公告
        noticeDetail(item) {
            this.$dialog.alert({
                title: item.noticeTitle,
                message: item.noticeContent,
                theme: 'round-button',
            }).then(() => {
                // on close
            });
        },

        // 加载公告
        async getNotice() {
            this.notices = []
            const list = await home.getSysNotice()
            this.notices = list
        }
    }
}
</script>

<style scoped>
/* 轮播样式 */
.my-swipe ::v-deep {
    /* border: 5px solid red; */
    border-radius: 8px;
    margin-top: 15px;
}

.my-swipe .van-swipe-item {
    border-radius: 8px;
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
}

.my-swipe ::v-deep .van-swipe-item img {
    width: 100%;
    height: 100%;
}

/* 快捷菜单样式 */
.mine-col {
    margin-top: 10px;
}

.mine-col .van-col {
    color: #202020;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    background-clip: content-box;
}

.mine-col .van-col span {
    display: block;
    color: #202020;
    height: 20px;
    margin-top: 4px;
}

.mine-col .van-col .menu-icon-bg {
    margin: auto;
    width: 40px;
    height: 40px;
    line-height: 44px;
    background-color: chocolate;
    border-radius: 8px;
}

.mine-col .van-col .bg-color1 {
    background-image: linear-gradient(135deg, #FEB692 10%, #EA5455 100%);
}

.mine-col .van-col .bg-color2 {
    background-image: linear-gradient(135deg, #5EFCE8 10%, #736EFE 100%);
}

.mine-col .van-col .bg-color3 {
    background-image: linear-gradient(135deg, #E2B0FF 10%, #9F44D3 100%);
}

.mine-col .van-col .bg-color4 {
    background-image: linear-gradient(135deg, #FDD819 10%, #E80505 100%);
}

.mine-col .van-col .bg-color5 {
    background-image: linear-gradient(135deg, #2AFADF 10%, #4C83FF 100%);
}

/* 通知栏样式 */
.notice-swipe {
    height: 24px;
    line-height: 24px;
}

.van-notice-bar {
    height: 24px;
    line-height: 24px;
    padding: 0;
    background: none;
    margin-top: 10px;
}
</style>